module.exports = __webpack_public_path__ + "img/1.57738a53.png";